import React, { useState, useEffect } from 'react'
import Grid from '@mui/material/Grid'
import { Paper, Typography, Button, List, ListItem, ListItemIcon, DialogContent, DialogContentText, DialogActions, TextField, Box, InputAdornment } from '@mui/material';

import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import FunctionsOutlinedIcon from '@mui/icons-material/FunctionsOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import DateRangeIcon from '@mui/icons-material/DateRange';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import hashFill from '@iconify/icons-eva/hash-fill';
import ClearIcon from '@mui/icons-material/Clear';
import { Icon } from '@iconify/react';


import LeftIcon from '../../../assets/icons/join_left.svg'
import RightIcon from '../../../assets/icons/join_right.svg'
import InnerIcon from '../../../assets/icons/join_inner.svg'
import { ReactComponent as InputSearchIcon } from "../../../assets/icons/icon-feather-search.svg"




function JoinConfig({ joinDatasets, handleApplyJoin, joinConfig,handleDimensions, configCloseHandler }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [joinNodeMenuEl, setJoinNodeMenuEl] = useState(null);
  const [searchInput, setSearchInput] = useState('')
  const [filteredClauseList,setFilteredClauseList] = useState([])
  const [joinCondition,setJoinCondition] = useState([])
  const [measureList,setMeasureList] = useState([])
  const [fieldType, setFieldType] = useState('')
  const [currentIndex,setCurrentIndex] = useState(null)
  const [joinType,setJoinType] = useState('LEFT')


  const handleCreateJoin = () => {
    //console.log('create join')
    //handleDimensions()
    joinConfig.joinType = joinType
    handleApplyJoin({...joinConfig})
  }

  const handleConfigDrop = (event, type,index) => {
    setSearchInput('')
    setAnchorEl(event.currentTarget);
    setFieldType(type)
    setCurrentIndex(index)
    let measures = []
    if(type == 'primary'){
      measures = joinDatasets.find( obj => obj._id == joinConfig.primary.dataSetId).dimensions//.filter(obj => obj.dataSetType == 'DIMENSION')
      setFilteredClauseList(measures)
      setMeasureList(measures)
    }else if(type == 'secondary') {
      measures = joinDatasets.find( obj => obj._id == joinConfig.secondary.dataSetId).dimensions//.filter(obj => obj.dataSetType == 'DIMENSION')
      setFilteredClauseList(measures)
      setMeasureList(measures)
    }else{
      let m1 = joinDatasets.find( obj => obj._id == joinConfig.primary.dataSetId).dimensions.map(obj => {return {...obj}})
      let m2 = joinDatasets.find( obj => obj._id == joinConfig.secondary.dataSetId).dimensions.map(obj => {return {...obj}})
      let allMeasures = [...(m1.map(obj => {obj.name = `${joinConfig.primary.dataSetName}.${obj.name}`;obj.sql = `${joinConfig.primary.dataSetName}.${obj.sql}`; return {...obj}})),...(m2.map(obj => {obj.name = `${joinConfig.secondary.dataSetName}.${obj.name}`;obj.sql = `${joinConfig.secondary.dataSetName}.${obj.sql}`; return {...obj}}))]
      setFilteredClauseList(allMeasures)
      setMeasureList(allMeasures)
    }
  }

  const addClause = (e) => {
    setJoinNodeMenuEl(e.target)
  }

  const clearSelectedClause = (index) => {
    //console.log('remove',index)
    joinConfig.joinCondition.splice(index,1)
    setJoinCondition([...joinConfig.joinCondition])
    setJoinNodeMenuEl(null)
    //console.log(joinConfig)
  }

  const handleJoinType = (joinType) => {
    setJoinType(joinType)
  }

  const handleSearchDataSetClause = (e) => {
    e.stopPropagation()
    const value = e?.target?.value
    setSearchInput(value)
  }

  const clickMeasureListHandler = (e , measure, index) => {
    //console.log(index,currentIndex)
    e.stopPropagation()
    setSearchInput('')
    joinConfig.joinCondition[currentIndex].primaryFieldType = measure.type
    if(fieldType == 'primary'){
      joinConfig.joinCondition[currentIndex].primaryFieldName = `${joinConfig.primary.dataSetName}.${measure.sql}`
    }else if(fieldType == 'secondary'){
      joinConfig.joinCondition[currentIndex].secondaryFieldName = `${joinConfig.secondary.dataSetName}.${measure.sql}`
    }else{
      joinConfig.joinCondition[currentIndex].primaryFieldName = `${measure.sql}`    
    }
    //console.log(joinConfig.joinCondition)
    setJoinCondition(joinConfig.joinCondition)
    setSearchInput('')
    setFilteredClauseList([])
    setAnchorEl(null);
  }

  const closeConditionTypeMenu = (e) => {
    setJoinNodeMenuEl(null)
  }

  const handleSelectConditionType = (type) => {   
    joinConfig.joinCondition.push(
      {
        type:type,
        primaryFieldName:'',
        primaryDataset:joinConfig.primary.dataSetId,
        primaryFieldType:'',
        secondaryDataset:joinConfig.secondary.dataSetId,
        secondaryFieldName:''
      }
    )
    setJoinCondition(joinConfig.joinCondition)
    setJoinNodeMenuEl(null)
  }

  const handleStaticValue = (e,index) => {    
    joinConfig.joinCondition[index].secondaryFieldName = e.target.value
    setJoinCondition(joinConfig.joinCondition)
  }

  const handleClose = (e) => {
    e.stopPropagation()
    let empty = ''
    setSearchInput(empty)
    setFilteredClauseList([])
    setAnchorEl(null);
  };

  useEffect(() => {
    if(measureList.length > 0){
      let measures = []
      if(searchInput){
        measures = measureList.filter(obj => obj.name.toLowerCase().includes(searchInput.toLowerCase()) || (obj.displayName && obj.displayName.toLowerCase().includes(searchInput.toLowerCase())))
      }else{
        measures = measureList
      }
      setFilteredClauseList(measures)
    }
  },[searchInput])

  useEffect(() => {
    if(joinConfig){
      if(joinConfig.joinType){
        setJoinType(joinConfig.joinType)
      }
      if(joinConfig.joinCondition.length > 0){
        setJoinCondition(joinConfig.joinCondition)
      }
    }
  }, [joinConfig])

  useEffect(() => {
    if(joinDatasets && joinConfig && joinDatasets.length > 0){
      console.log('Dimension')
      handleDimensions()
    }
  },[joinDatasets])


  return (
    joinConfig && (
      <React.Fragment>
        <Grid item lg={12} xs={12}>
          <Paper className="join_clause_container join_clause_title">
            <Typography variant="h6">Join Configuration</Typography>
            <div>
              <Button variant="outlined" onClick={configCloseHandler} color="secondary" className="report_form_ui_btn cancel">Cancel</Button>
              &nbsp;&nbsp;
              <Button variant="contained" onClick={handleCreateJoin} color="primary" className="report_form_ui_btn submit">Apply</Button>
            </div>
          </Paper>
        </Grid>
        <Grid item lg={12}>
          <Grid container spacing={2} className="join_clause_body">
            <Grid item lg={6} sm={6} xs={12}>
              <Paper elevation={3} className="add_new_clause">
                <div className="join_clause_container add_new_clause_header">
                  <Typography variant="p">Join clause</Typography>
                  <Button onClick={e => addClause(e)} variant="outlined" color="secondary">+ Add new join clause</Button>
                  <Menu   
                    style={{marginRight:'10px'}}
                    id="simple-menu"
                    anchorEl={joinNodeMenuEl}
                    keepMounted
                    open={joinNodeMenuEl ?? false}
                    onClose={e => closeConditionTypeMenu(e)}
                    
                    >
                    <MenuItem className='menu-item' onClick={e => handleSelectConditionType('static')} value="remove">Static Condition</MenuItem>
                     <MenuItem className='menu-item' onClick={e => handleSelectConditionType('dynamic')} value="remove">Dynamic Condition</MenuItem>
                  </Menu>
                </div>
                <div className="join_clause_header">
                  <Box className="join_clause_header_heading">
                    <div className="col">
                      <Typography variant="h7" className='join_clause_item_text' >
                        {joinConfig.primary.dataSetName}
                      </Typography>
                    </div>
                    <div className="col">
                      <Typography variant="h7" className='join_clause_item_text' >
                        {joinConfig.secondary.dataSetName}
                      </Typography>
                    </div>
                  </Box>
                  <Box display="flex" justifyContent="space-between">                    
                      {
                        joinCondition.length > 0 && joinCondition.map((obj, index) => {
                          return (
                            <>                              
                              { //console.log(obj)
                                (obj.type == 'static') ? (
                                  <Box className="join_clause_header_content">
                                    <div className="col" key={`static-${index}-${obj.primaryDataset}`}>
                                      <Box sx={{ my: 1 }}>
                                        <Button aria-controls="simple-menu" style={{ marginTop: '10px', marginBottom: '10px' }} aria-haspopup="true" onClick={e => handleConfigDrop(e, 'all',index)} variant="outlined" className='report_form_ui_btn'>
                                          <Typography className="join_clause_header_content_btn">{obj.primaryFieldName ? obj.primaryFieldName :'Select Field'}</Typography>
                                        </Button>
                                      </Box>
                                    </div>
                                    <div className="col" key={`static-${index}-${obj.secondaryDataset}`}>
                                      <Box sx={{ my: 1 }}>
                                        <TextField onChange={e => handleStaticValue(e,index)} defaultValue={obj.secondaryFieldName} style={{ marginTop: '10px', marginBottom: '10px' }} className="join_clause_header_content_btn" />
                                      </Box>
                                    </div>
                                    {(index > 0) && 
                                      <Box className="clear_btn" sx={{ pr: 2, width: '32px' }}>
                                        <Button className="form_icon" color="secondary" size="small" style={{ marginTop: '20px', minWidth: '24px' }} onClick={e => clearSelectedClause(index)}>
                                          <ClearIcon className="join_clear_icon" />
                                        </Button>
                                      </Box>
                                    }
                                  </Box>
                                ) : (
                                      <Box className="join_clause_header_content">
                                        <div className="col" key={`dynamic-${index}-${obj.primaryDataset}`}>
                                          <Box sx={{ my: 1 }}>
                                            <Button aria-controls="simple-menu" style={{ marginTop: '10px', marginBottom: '10px' }} aria-haspopup="true" onClick={e => handleConfigDrop(e, 'primary',index)} variant="outlined" className='report_form_ui_btn'>
                                              <Typography className="join_clause_header_content_btn">{obj.primaryFieldName ? obj.primaryFieldName.split('.')[1] :'Select Field'}</Typography>
                                            </Button>
                                          </Box>                                                                                
                                        </div>
                                        <div className="col" key={`dynamic-${index}-${obj.secondaryDataset}`}>
                                          <Box sx={{ my: 1 }}>
                                            <Button aria-controls="simple-menu" style={{ marginTop: '10px', marginBottom: '10px' }} aria-haspopup="true" onClick={e => handleConfigDrop(e, 'secondary',index)} variant="outlined" className='report_form_ui_btn'>
                                              <Typography className="join_clause_header_content_btn">{obj.secondaryFieldName ? obj.secondaryFieldName.split('.')[1] :'Select Field'}</Typography>
                                            </Button>
                                          </Box>
                                        </div>
                                        {(index > 0) && 
                                          <Box className="clear_btn" sx={{ pr: 2, width: '32px' }}>
                                            <Button className="form_icon" color="secondary" size="small" style={{ marginTop: '20px', minWidth: '24px' }} onClick={e => clearSelectedClause(index)}>
                                              <ClearIcon className="join_clear_icon" />
                                            </Button>
                                          </Box>
                                        }
                                      </Box>
                                    )
                              }                                                            
                            </>
                          )
                        })

                      }
                  </Box>
                </div>
              </Paper>
            </Grid>
            <Grid item lg={6} sm={6} xs={12}>
              <Paper elevation={3} className="join_type">
                <Typography variant="h7">
                  Join Types
                </Typography>
                <div className="join_clause_content" >                  
                  <Button onClick={e => handleJoinType('LEFT')} className={joinType === 'LEFT' ? "visualize_list_text form_icon" : ""}>
                    <div className="join_types_div">
                      <img src={LeftIcon} alt="join_icon" className="join_types_icon" />
                      <span className='text-small'>Left</span>
                    </div>
                  </Button>
                  <Button className={joinType === 'RIGHT' ? "visualize_list_text form_icon":""} onClick={e => handleJoinType('RIGHT')}>
                    <div className="join_types_div">
                      <img src={RightIcon} alt="join_icon" className="join_types_icon" />
                      <span className='text-small'>Right</span>
                    </div>
                  </Button>
                  <Button className={joinType === 'INNER' ? "visualize_list_text form_icon" :""} onClick={e => handleJoinType('INNER')}>
                    <div className="join_types_div">
                      <img src={InnerIcon} className="join_types_icon " alt="join_icon" />
                      <span className='text-small'>Inner</span>
                    </div>
                  </Button>
                </div>
              </Paper>
            </Grid>
          </Grid>
        </Grid>

        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={e => handleClose(e)}
          >
          <MenuItem className='menu-item-single join-clause-field-selection'  style={{height:'50%'}}>
            <div>
              <Box width="100%" height="100%" mt={2}>
                <Typography className="report-form-label" variant="subtitle1">Fields list</Typography>
                <TextField className="cm_rprt_setting_content  report_input_field_list" type="search" size="medium" placeholder="Search field"
                value={searchInput}
                  onChange={handleSearchDataSetClause}
                  InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                        <InputSearchIcon className="input_search_icon" sx={{mr: '8px'}} />
                    </InputAdornment>
                  ),
              }} />
              </Box>
              <div className="field_list" >
                <List component="nav" >
                  {filteredClauseList.map((measure, i) => {
                    return (
                      <ListItem key={measure._id} button={true} onClick={(e) => clickMeasureListHandler(e, measure, i)}>
                        <ListItemIcon>
                          {measure.dataSetType === "MEASURE" ? <FunctionsOutlinedIcon className="cm_dimension_icon" /> : measure.type === "number" ? <Icon icon={hashFill} className="cm_measr_lbl num_icon" /> : measure.type === "time" ? <DateRangeIcon className="cm_measr_lbl"/> : <LabelOutlinedIcon className="cm_measr_lbl" />}
                        </ListItemIcon>
                        <Typography> {measure?.displayName ? measure?.displayName : measure?.name} </Typography> 
                      </ListItem>
                    )
                  })}
                </List>
              </div>
            </div>
          </MenuItem>
        
        </Menu>

      </React.Fragment>
    )
  )
}

export default JoinConfig
